import React from 'react';
import Icons from '../Icons';
import { FooterContainer, IconContainer } from './styles';

const SOCIAL_LINKS = [
  { id: 1, icon: 'instagram', link: 'https://www.instagram.com/' },
  {
    id: 2,
    icon: 'facebook',
    link: 'https://www.facebook.com',
  },
  { id: 3, icon: 'twitter', link: 'https://twitter.com/' },
];

const Footer = () => {
  return (
    <FooterContainer>
      {SOCIAL_LINKS.map(({ id, icon, link }) => (
        <li key={id}>
          <IconContainer href={link}>
            <Icons icon={icon} />
          </IconContainer>
        </li>
      ))}
    </FooterContainer>
  );
};

export default Footer;
